import { Link } from 'react-router-dom';

export function HeroSection() {
  return (
    <section>
      <div className="space-y-4">
        <h1 className="text-3xl font-bold tracking-tight text-foreground lg:text-4xl">
          Skystone is your common place for P&amp;E metrics
        </h1>
        <p className="max-w-3xl text-muted-foreground">
          One trusted source of truth for engineering, code quality, product flow, product
          analytics and business KPIs &mdash; shaped to how each user works, governed for
          continuous improvement, built to help every team and leader make faster, data-based
          decisions.
        </p>
        <div className="flex flex-wrap gap-2 pt-2">
          <Link
            to="/metric-view"
            className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Browse metrics &rarr;
          </Link>
          <Link
            to="/metric-catalogue"
            className="inline-flex h-10 items-center justify-center rounded-md bg-secondary px-4 text-sm font-medium text-secondary-foreground transition-colors hover:bg-secondary/80"
          >
            Open Definitions Catalogue
          </Link>
        </div>
      </div>
    </section>
  );
}
